document.addEventListener('DOMContentLoaded', function () {
   let riverSlots = [];
   let riverAdCb = Appleinsider.cb;
   let reverAdCurEl = null;
   let reverAdCurName = '';

   const riverTemplate = Handlebars.compile(document.querySelector('#river-template').innerHTML);
   const adTemplate = Handlebars.compile(document.querySelector('#river-ad-template').innerHTML);
   
   const navToc = document.querySelector('nav.toc');
   const navTocToggle = document.querySelector('.toc-toggle');

   const dynamicRiverAds = {
      'slots' : [],
      'cb' : Appleinsider.cb
   }
   
   let url = '';
   let currentPage = 0;
   let nextPage = currentPage + 1;

   let pagination_element = document.getElementById('river-load-more');
   if( pagination_element ) {
      url = pagination_element.getAttribute('data-href');
      currentPage = parseInt(pagination_element.getAttribute('data-current-page'));
      nextPage = currentPage + 1;
   }

   /*
         This will restore our middle mouse click functionality to the "links" 
         ref: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
   */
   let inputs = document.querySelectorAll('.price-guide input[type=submit]');
   inputs.forEach(function(input, i){
            input.addEventListener('mouseup', function(e){
                     if(e.button && e.button === 1) {
                           e.preventDefault();
                           input.parentNode.submit();
                     }
            });
   });

   $('#load-more, #river-load-more').on( 'click', function(e){
      $('#river-load-more').attr('data-current-page', nextPage );
      url = url.replace(/\/page\/(\d+)/, '/page/' + nextPage);
      $('#load-more-link-text').hide();
      $('#river-load-more .ispinner').addClass('ispinner--animating');
      $('.ispinner').show();

      $.ajax( {
         url: url,
         success: function( response ){
            nextPage++;
            let adFreq = 10;
            let adCursor = 0;
            let i = 0;
            if(response.length > 0 ) {
               $('.ispinner').hide();
               $('#load-more-link-text').show();
               response.forEach(element => {
                  let data = element;
                  // Let's not do this on the deals page or the videos page
                  if( url.includes('deals/page') === false && url.includes('videos/page') === false ){
                     if(adCursor == adFreq){
                        $('#news-river:last').append(
                           adTemplate()
                        ).append("<hr>");
                        adCursor = 1;
                     } else {
                        adCursor++;
                     }
                  }

                  if( url.includes('videos/page') ){
                     if( i % 4 == 0 ) {
                        $('#news-river').append(
                           '<div class="row">'
                        );
                     }
                  }

                  $('#news-river').append(
                     riverTemplate(data)
                  );

                  if( url.includes('videos/page') ){
                     if( i % 4 == 0 ) {
                        $('#news-river').append(
                           '</div>'
                        );
                     }
                  }

                  $('#river-load-more .ispinner').removeClass('ispinner--animating');
                  $('#load-more-link').attr('data-href', url);
                  $('#load-more-link').attr('href', url);
                  i++;
               });

               i++;
               riverSlots = [];
               if(typeof loadMoreCallback === 'function') {
                  loadMoreCallback();
               }
            } else {
               $('#news-river').append( '<h2 class="fauxh1 text-center">🤠💬 I reckon this is the end of the road, pardner</h2>');
               $('#river-load-more').remove();
            }
         },
         statusCode: {
            500: function(e){
               $('#news-river').append( '<h2 class="fauxh1 text-center">🤠💬 I reckon this is the end of the road, pardner</h2>');
               $('#river-load-more').remove();
            }
         }
      });

      e.stopPropagation();
      e.preventDefault();
   });

   /* New Drawers, ToC, etc. */ 
   $('.pg-button, .pg-coupon-button, .pg-button-coupon-overlay').on('click', function(e){
      $('.pg-ddMenu.open').removeClass('open');
      let a = $(this).parents('li:first').siblings('.pg-ddMenu').toggleClass('open');

      e.preventDefault();
      e.stopPropagation();
    });

    $('body').on('keydown', function(e) {
      if(e.keyCode == 27){
        $('.pg-ddMenu.open').removeClass('open');
      }
    });

    $('body').on('click', function(e) {
      $('.pg-ddMenu.open').removeClass('open');
    });

    let drawers = document.querySelector('.drawer-content');
    let scrollLeft = [];
    let isDown = [];
    let startX = [];

    if(drawers){
      for(let i = 0; i < drawers.length; i++){
         drawers[i].addEventListener('mousedown', (e) => {
            isDown[i] = true;
            startX[i] = e.pageX - drawers[i].offsetLeft;
            scrollLeft[i] = drawers[i].scrollLeft;
         });

         drawers[i].addEventListener('mouseleave', () => {
            isDown[i] = false;
         });

         drawer[i].addEventListener('mouseup', () => {
            isDown[i] = false;
         });

         drawers[i].addEventListener('mousemove', (e) => {
            if(!isDown[i]) return;
            e.preventDefault();
            const x = e.pageX - drawers[i].offsetLeft;
            const walk = (x - startX[i]) * 2;
            drawers[i].scrollLeft = scrollLeft[i] - walk;
         });
      }
   }

   $('.drawer-handle').on('click', function(e){
      let el = $(this).parents('.ai-drawer:first');
      $('.pg-ddMenu.open').removeClass('open');

      if( el.hasClass('open') ) {
         if(!el.hasClass('a-z')){
            el.css('height', '7em');
            el.scrollLeft = 0;
            el.scrollTop = 0;
         } else {
            el.css('height', '8em');
            el.scrollLeft = 0;
            el.scrollTop = 0;
         }
      } else {
         if(!el.hasClass('a-z')){
            el.css('height', '75vh');
            el.scrollLeft = 0;
            el.scrollTop = 0;
         } else {
            el.css('height', 'auto');
            el.scrollLeft = 0;
            el.scrollTop = 0;
         }
      }
      
      $(this).parents('.ai-drawer:first').toggleClass('open');

      e.stopPropagation();
      e.preventDefault();
   });

   /* Color switcher */
   let themeButton = document.getElementById('toggle-theme');
   let themeIcon = document.getElementById('the-lights');

   themeButton.addEventListener('click', (e) => {      
      if(localStorage.getItem('theme')){
         appleinsiderTheme = (localStorage.getItem('theme') == 'light') ? 'dark' : 'light';
      } else {
         appleinsiderTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'light' : 'dark'; // opposite
      }

      localStorage.setItem('theme', appleinsiderTheme);

      if(appleinsiderTheme == 'dark'){
         themeIcon.setAttribute('fill', 'var(--theme-toggle)');
      } else {
         themeIcon.setAttribute('fill', 'var(--theme-toggle)');
      }

      document.documentElement.setAttribute('data-color-mode', appleinsiderTheme);

      e.preventDefault();
      e.stopPropagation();
   });

   /* Video overlay clicks */
   let videos = document.querySelectorAll('.video-holder');
   videos.forEach( el => el.addEventListener('click', event => {
      let embed = el.getAttribute('data-video');

      el.classList.add('embed-responsive');
      el.classList.add('embed-responsive-16by9');
      el.innerHTML = '<iframe loading="lazy" src="'+embed+'" class="embed-responsive-item" autoplay allowfullscreen></iframe>';

      event.stopPropagation();
   }));

   /* New NEW table of Contents for inside pages */
   $('.new-toc').on('click', function(e){
      if($(this).hasClass('new-toc-closed')){
        document.body.classList.add('nav-lock-body-scroll');

        $(this).removeClass('new-toc-closed').addClass('new-toc-open');
        $(this).children('.col-xs-12:first').children('.toc-items:first').css('display', 'block');

        e.preventDefault();
      }      
    });

    $('.new-toc-close').on('click', function(e){
      let p = $(this).closest('.new-toc');
      document.body.classList.remove('nav-lock-body-scroll');

      p.removeClass('new-toc-open').addClass('new-toc-closed');
      p.children('.col-xs-12:first').children('.toc-items:first').css('display', 'none');

      e.preventDefault();
      e.stopPropagation();
    });

    $('.toc-items ol li a, .toc-items .ai-button').on('click', function(e){
      let p = $(this).closest('.new-toc');
      document.body.classList.remove('nav-lock-body-scroll');

      p.removeClass('new-toc-open').addClass('new-toc-closed');
      p.children('.col-xs-12:first').children('.toc-items:first').css('display', 'none');

      e.stopPropagation();
    });

   /* GDPR check for MS Clarity */
   if(window.admiral){
      window.admiral('after','cmp.loaded',function(e){
         if(!e.euVisitor){
            if(window.clarity){
               window.clarity('consent');
            }

            gtag('consent', 'update', {
               'analytics_storage': 'granted'
            });
            console.log('consent updated for Non EU resident.');
         } else {
            if(window.clarity){
               window.clarity('consent');
            }
         }
      });
   }
});
